<template>
	<aside
		v-if="moduleData
			&& moduleData.items
			&& moduleData.items.length > 0"
		class="module module-unified-right-rail interactive"
		:class="['module-' + metrics.module, getLabel]"
		:id="metrics.module"
		v-metric="{ module: metrics.module }"
		role="complementary"
	>
		<header v-if="moduleData.moduleTitle && moduleData.moduleTitle.text">
			<h3>{{ moduleData.moduleTitle.text }}</h3>
			<h4 v-if="moduleData.description">
				{{ moduleData.description }}
			</h4>
		</header>

		<div
			:class="metrics.module.includes('ed-urr')
				? 'unified_right_inner_v2_rdr' : 'unified_right_inner_rdr'"
		>
			<template
				v-for="(item, index) in moduleData.items"
				:key="createKey(index)"
			>
				<div
					:class="item.class"
					:id="createKey(index)"
				>
					<a
						v-if="item.link"
						v-metric:track="{
							link: entryMetricsLink(index, item.title)
						}"
						:href="item.link"
					>
						<img
							v-if="item.img"
							:src="item.img"
							:alt="item.imgalt"
						/>
						<span
							v-if="item.title"
							class="asset-type"
						>
							{{ item.title }}
						</span>
						<h4 v-if="item.paragraph">
							{{ item.paragraph }}
						</h4>
					</a>
				</div>
			</template>
		</div>
	</aside>
</template>

<script>
import useStore from 'webmd-cms-store/src/store';


import _has from 'lodash/has';
import _isArray from 'lodash/isArray';
import _isObject from 'lodash/isObject';

export default {
	props: {
		chronicId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			metrics: {
				module: '',
			},
			moduleByChronicId: {},
			moduleData: {},
			specialReportModule: false,
		};
	},
	computed: {
		getItems() {
			if (!this.moduleByChronicId) {
				return [];
			}

			const module = this.moduleByChronicId;
			const moduleTitle = this.metrics.module.toLowerCase();

			const imageBaseUrl = this.store?.pagedata?.omniture?.image_server_url || 'https://img.webmd.com/dtmcms/live';

			let items = _has(module, 'module_data.links.link')
				? module.module_data.links.link.map((link, index) => {
					let resizePX = 69;

					if (this.getLabel === 'health-heroes'
						|| moduleTitle.includes('ed-urr')
						|| (_has(module, 'module_settings.dynamic_module_title') && module.module_settings.dynamic_module_title.toLowerCase().includes('ia-sr-rr'))
						|| (_has(module, 'module_settings.title') && module.module_settings.title.toLowerCase().includes('ia-sr-rr'))) {
						resizePX = 110;
					} else if (moduleTitle.includes('prmvd-rt')) {
						resizePX = index === 0 ? 315 : 150;
					}
					return {
						paragraph: _has(link, 'action_text') ? link.action_text : '',
						title: _has(link, 'link_text') ? link.link_text : '',
						link: _has(link, 'link_url.link_friendlyUrl') ? link.link_url.link_friendlyUrl : '',
						img: _has(link, 'link_source_icon.path') ? `${imageBaseUrl}${link.link_source_icon.path}?resize=${resizePX}px:*&amp;output-quality=50` : '',
						imgalt: _has(link, 'link_source_icon.alt') ? link.link_source_icon.alt : '',
						class: 'entry_fmt',
					};
				})
				: [];

			// eslint-disable-next-line
			const moduleTitleText = module
			&& _has(module, 'module_data.module_title.title') ? module.module_data.module_title.title
				: (_has(module, 'module_data.module_title') ? module.module_data.module_title : '');

			// eslint-disable-next-line
			const moduleTitleLink = module
				&& (_has(module, 'module_data.module_link.link_friendlyUrl')
					? module.module_data.module_link.link_friendlyUrl : '');

			let description = '';

			if (module && _has(module, 'module_data.descriptions')) {
				if (_isObject(module.module_data.descriptions.description)
					&& _has(module, 'module_data.descriptions.description.description_text')
					&& _has(module, 'module_settings.dynamic_module_title')
					&& module.module_settings.dynamic_module_title.toLowerCase().includes('ia-sr-rr')) {
					description = module.module_data.descriptions.description.description_text;
				} else if (_isArray(module.module_data.descriptions.description)
					&& _has(module, 'module_data.descriptions.description[0].description_text')
					&& _has(module, 'module_settings.dynamic_module_title')
					&& module.module_settings.dynamic_module_title.toLowerCase().includes('ia-sr-rr')) {
					description = module.module_data.descriptions.description[0].description_text;
				}
			}

			items = items.filter((i) => i && i.link);

			return {
				moduleTitle: {
					text: moduleTitleText,
					link: moduleTitleLink,
				},
				description,
				items,
			};
		},

		getModuleByChronicId() {
			return this.store.cms.getModules(this.chronicId);
		},
		getLabel() {
			if (!this.moduleByChronicId) {
				return false;
			}

			if (_has(this.moduleByChronicId, 'module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val')) {
				// eslint-disable-next-line max-len
				const storageVal = this.moduleByChronicId.module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val;
				const label = storageVal ? storageVal.toLowerCase() : '';
				if (label.includes('health')) return 'health-heroes';

				if (label.includes('special') || (_has(this.moduleByChronicId, 'module_settings.dynamic_module_title') && this.moduleByChronicId.module_settings.dynamic_module_title.toLowerCase().includes('ia-sr-rr'))) return 'special-reports';
			}
			return '';
		},
	},

	methods: {
		entryMetricsLink(i, title) {
			const lowercaseTitle = title ? title.toLowerCase() : '';

			switch (lowercaseTitle) {
				case 'video': return `${i + 1}vid`;
				case 'feature': return `${i + 1}ftr`;
				case 'slideshow': return `${i + 1}ss`;
				case 'quiz': return `${i + 1}rmq`;
				default: {
					if (this.metrics.module && this.metrics.module.toLowerCase().includes('prmvd-rt')) return (i + 1);
					if (this.metrics.module && this.metrics.module.toLowerCase().includes('ia-sr-rr')) return (i + 1);
					return `${i + 1}othr`;
				}
			}
		},
		createKey(i) {
			return `dfp_slot_tow${i + 1}`;
		},
		getMetrics() {
			if (!this.moduleByChronicId) {
				return false;
			}

			// eslint-disable-next-line max-len
			const storageVal = _has(this.moduleByChronicId, 'module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val') ? this.moduleByChronicId.module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val : '';
			const label = storageVal ? storageVal.toLowerCase() : '';

			if (label.includes('special') || (_has(this.moduleByChronicId, 'module_settings.dynamic_module_title')
				&& this.moduleByChronicId.module_settings.dynamic_module_title.toLowerCase().includes('ia-sr-rr'))) {
				this.specialReportModule = true;
			}

			if (!this.specialReportModule && _has(this.moduleByChronicId, 'module_settings.title')) {
				return this.moduleByChronicId.module_settings.title;
			}

			if (this.specialReportModule && _has(this.moduleByChronicId, 'module_settings.dynamic_module_title')) {
				return this.moduleByChronicId.module_settings.dynamic_module_title;
			}
			return '';
		},
	},

	created() {
       this.store = useStore(this.$pinia);
		this.moduleByChronicId = this.getModuleByChronicId;
		this.metrics.module = this.getMetrics();
		this.moduleData = this.getItems;
		this.store.cms.SET_RENDERED(this.chronicId);
	},

};
</script>

<style lang="scss">
$base-font-family-sans: "Source Sans Pro", Verdana, sans-serif;
$font-family-robo: "Roboto Condensed",Verdana,sans-serif;
// UI Colors - Text
$dark-grey: #4a4a4a;
$header-black: #333132;
$dark-teal: #3a6d69;
// UI Colors - Graphics
$grey: #f5f3f2;
$light-grey: #e8e6e6;

#more-honorees-rr {
	& .unified_right_inner_rdr {
		& .entry_fmt {
			margin-bottom: 1rem;
			padding-bottom: 0px;
			& a {
				display: inline-block;
				padding: .25rem 0;
			}
		}
		& h4 {
			font-weight: normal;
			width: 18.307625rem;
			margin-top: 0px;
		}
	}
}

.module-unified-right-rail {
	&.interactive {
		border-top: .3125rem solid $light-grey;
		margin: 0 0 2.8125rem;
		padding: .875rem 0 0;
		width: 100%;

		h4, h3 {
			color: $header-black;
			font-family: $base-font-family-sans;
			font-weight: 700;
			line-height: 1;
		}

		header {
			h3 {
				margin: 0 0 .875rem;
				text-transform: uppercase;
			}
			h4 {
				text-transform: uppercase;
				font-size: 0.9rem;
				margin-bottom: .6435rem;
				margin-top: 0;
			}
		}

		.entry_fmt {
			font-family: $font-family-robo;
			overflow-y: auto;
			padding: .6875rem 0;

			&:first-child {
				border-top: .0625rem solid $light-grey;
			}

			h4 {
				font-size: 1rem;
				line-height: 1.25;
				margin: .375rem 0 .25rem 0;
			}

			a {
				color: $dark-grey;
				font-size: .875rem;
				text-decoration: none;

				&:hover {
					text-decoration: underline;
				}
			}

			img {
				clear: both;
				float: left;
				margin-right: 1rem;
			}

			.asset-type {
				color: $dark-teal;
				display: block;
				font-size: .75rem;
				font-weight: 700;
				letter-spacing: .01875rem;
				margin-bottom: .25rem;
				margin-top: .125rem;
				text-transform: uppercase;
			}
		}
		// EXPERT OPINION MODULE
		&.module-ia-sr-rr2 {
			letter-spacing: -0.017069rem;
			line-height: 1.43;
		}

		&.special-reports {
			& header {
				& h3 {
					text-transform: none;
					font-size: 1.5rem;
				}
				& h4 {
					font-size: 0.9rem;
					text-transform: uppercase;
					margin: 0 0 .6435rem; // margin-bottom: 10.296px;
				}
			}
			& .entry_fmt {
				font-family: $base-font-family-sans;
				& a {
					letter-spacing: -0.017069rem;
					line-height: 1.25125rem;
					& .asset-type {
						font-family: $font-family-robo;
						margin-top: 0;
						line-height: 1.0725rem;
					}
					& h4 {
						margin-block-start: 0;
						margin-top: 0;
					}
				}
			}

		}
	}
}
</style>
